import { render } from "./CompleteStep.vue?vue&type=template&id=aab0ec1a&ts=true"
import script from "./CompleteStep.vue?vue&type=script&lang=ts"
export * from "./CompleteStep.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__